import React from 'react';
import PropTypes from 'prop-types';
import { getCookieName } from '../../utils/cookies'


const appProviderHOC = (initValue = {}) => {
  const AppContext = React.createContext({
    state: {
      theme: {},
      messages: [],
      userSettings: {
        gdprPreferencesEnabled: getCookieName('gdpr_preferences_set', 'false'),
        gdprAnalyticsEnabled: getCookieName('gdpr_analytics_on', 'false'),
      },
      ...initValue,
    },
  });

  class AppProvider extends React.PureComponent {
    constructor(props) {
      super(props);
      this.state = {
        theme: {},
        messages: [],
        userSettings: {
          gdprPreferencesEnabled: getCookieName('gdpr_preferences_set', 'false'),
          gdprAnalyticsEnabled: getCookieName('gdpr_analytics_on', 'false'),
        },
        ...initValue,
      };
    }

    setter = (data) => {
      this.setState((state) => ({ ...state, ...data }));
    }

    render() {
      const { children } = this.props;

      return (
        <AppContext.Provider
          value={{
            state: this.state,
            setter: this.setter,
          }}
        >
          {children}
        </AppContext.Provider>
      );
    }
  }

  AppProvider.propTypes = {
    children: PropTypes.node.isRequired,
  };

  return { AppContext, AppProvider };
};

export default appProviderHOC;
